import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MergeFilledSvg from "@ant-design/icons-svg/es/asn/MergeFilled";
import AntdIcon from '../components/AntdIcon';
var MergeFilled = function MergeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: MergeFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(MergeFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'MergeFilled';
}
export default RefIcon;